module.exports = __webpack_public_path__ + "media/images/restaurant/en_sarvicegenre_bg02-b5ef1442af665ab9ccbc876a2553255d.png";